import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { kebabCase, join, map } from 'lodash';

import './BasicTable.scss';

const tableClass = (type) => classNames(
  'basic-table',
  { 'basic-table--detail-page': type === 'detail-page' },
);

const valueClass = (item) => classNames(
  'basic-table__text',
  { 'basic-table__text--italicize': item.italicize },
);

const ContactRows = ({ item }) => {
  if (item.label !== 'Sending User') return null;

  return (
    <div>
      {item.contactData?.email && (
        <div>Email: {item.contactData.email}</div>
      )}
      {item.contactData?.primaryNumber && (
        <div>Phone: {item.contactData.primaryNumber}</div>
      )}
    </div>
  );
};

const BasicTable = ({ data, id, type }) => (
  <table className={tableClass(type)} id={id} role="presentation">
    <tbody>
      {
          map(data, (item = {}, rowIndex) => (
            <tr
              className="basic-table__row"
              key={`basic-table-${rowIndex}`}
              role="presentation"
            >
              <td className="basic-table__text basic-table__text--label">
                {item.label}
              </td>
              <td
                id={kebabCase(join([id, item.label, 'value']))}
                className={valueClass(item)}
              >
                {item.value}

                <ContactRows item={item} />
              </td>
            </tr>
          ))
        }
    </tbody>
  </table>
);

BasicTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    italicize: PropTypes.bool,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node,
    ]),
    value: PropTypes.node,
    contactData: PropTypes.shape({
      email: PropTypes.string,
      primaryNumber: PropTypes.string,
    }),
  }).isRequired),
  id: PropTypes.string,
  type: PropTypes.string,
};

BasicTable.defaultProps = {
  data: [],
  id: 'basic-table',
  type: '',
};

ContactRows.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    contactData: PropTypes.shape({
      email: PropTypes.string,
      primaryNumber: PropTypes.string,
    }),
  }).isRequired,
};

export default BasicTable;
